module.exports = __webpack_public_path__ + "img/logo-zsolya.dd6b6b18.png";